import { Model } from "@vuex-orm/core";

export default class Telephony extends Model {
  static entity = "telephony";

  static fields() {
    return {
      id: this.attr(),
      token: this.attr(),
      tokenExpires: this.attr(),
      status: this.attr()
    };
  }
}
